<div class="row mr-0">
    <div class="col-12 msg-error">
        {{msgError}}
    </div>
</div>
